/**
 * @version:               1.0.0
 * @createTime:            2021.10.08
 * @updateTime:            2021.10.08
 * @author:                zhangju
 * @description
 ***/

import ccTab from '@/components/common/tab/index.vue';
import contentTable from '@/components/common/more-tab-content/content-table/index.vue';
export default {
    name: 'page-list',
    components: {ccTab, contentTable},
    data() {
        return {
            tabList: [
                {
                    name: '白皮书',
                    code: 'bps'
                },
                {
                    name: '司法建议',
                    code: 'sfjy'
                }
            ],
            active: 'bps'
        };
    },
    computed: {
        crumbsList() {
            const list = [{
                name:'审判通报',
                key:'sptb',
                path:'/sptb'
            }];
            const listItem = this.tabList.filter(item => item.code === this.active)[0];
            listItem.key = listItem.code;
            list.push(listItem);
            return Object.freeze(list);
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.active = this.$route.query.tab || 'bps';
        },
        // 页签切换
        handelTabChange(code) {
            this.active = code;
        }
    }
};
